import React from "react";
import { withStyles, CircularProgress } from "@material-ui/core";

const styles = (theme) => ({
  container: {
    flex: 1,
    display: "flex",
    backgroundColor: theme.ModalBGColor,
    justifyContent: "center",
    alignItems: "center",
  },
  content: {
    display: "flex",
    flexDirection: "column",
  },
  text: {
    color: theme.iconColor,
    fontSize: theme.textFontSize,
    fontWeight: 600,
    textTransform: "uppercase",
    lineHeight: "16px",
    paddingBottom: 20,
    paddingTop: 20,
  },
  progressIcon: {
    alignSelf: "center",
  },
});

const Loader = ({ classes }) => {
  return (
    <div className={classes.container}>
      <div className={classes.content}>
        <CircularProgress className={classes.progressIcon} />
        <div className={classes.text}>Region Update is in Progress</div>
      </div>
    </div>
  );
};

export default withStyles(styles)(Loader);
